import * as React from "react";
import { Box, Typography } from "@mui/material";
import { format } from "date-fns";

const rootSx = {
  px: 2,
  py: 2,
  textAlign: "center",
  width: "100%",
  boxSizing: "border-box",
};

/** Single-line summary (`MMM d, y · h:mm a`) instead of MUI’s split date / time / meridiem toolbar. */
export default function BDateTimePickerToolbar(props) {
  const { hidden, className, value, sx } = props;
  if (hidden) {
    return null;
  }

  const label =
    value != null
      ? format(value instanceof Date ? value : new Date(value), "MMM d, y • h:mm a")
      : "—";

  return (
    <Box
      p={1}
      component="div"
      className={className}
      sx={{ backgroundColor: "#ECECEC", textAlign: "center" }}
    >
      <Typography component="div">{label.toUpperCase()}</Typography>
    </Box>
  );
}
